import CreditCardIcon from "./icons/credit-card.svg";
import VisaElectronIcon from "./icons/visa-electron.svg";
import VisaIcon from "./icons/visa.svg";
import MastercardIcon from "./icons/mastercard.svg";
import MaestroIcon from "./icons/maestro.svg";
import RupayIcon from "./icons/rupay.svg";
import AmexIcon from "./icons/american-express.svg";
import DinersIcon from "./icons/diners.svg";
import DiscoverIcon from "./icons/discover.svg";
import JcbIcon from "./icons/jcb.svg";

const CARD_TYPES = [
  {
    name: "RUPAY",
    displayName: "Rupay",
    icon: RupayIcon,
    regex: /^(3536|3538|(508[5-9])|(60[6-8])|(65[2-3])|(817[2-3])|820199)\d+$/
  },
  {
    name: "VISA_ELECTRON",
    displayName: "Visa Electron",
    icon: VisaElectronIcon,
    regex: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/
  },
  {
    name: "DISCOVER",
    displayName: "Discover",
    icon: MaestroIcon,
    regex: /^(6011|64[4-9]|65)\d+$/
  },
  {
    name: "MAESTRO",
    displayName: "Maestro",
    icon: MaestroIcon,
    regex: /^(5[06789]|6)\d+$/
  },
  {
    name: "VISA",
    displayName: "Visa",
    icon: VisaIcon,
    regex: /^4\d+$/
  },
  {
    name: "MASTERCARD",
    displayName: "MasterCard",
    icon: MastercardIcon,
    regex: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)\d+$/
  },
  {
    name: "AMEX",
    displayName: "Amex",
    icon: AmexIcon,
    regex: /^3[47]\d+$/
  },
  {
    name: "DINERS",
    displayName: "Diners",
    icon: DinersIcon,
    regex: /^36\d+$/
  },
  {
    name: "JCB",
    displayName: "Jcb",
    icon: JcbIcon,
    regex: /^35\d+$/
  }
];

export const getBin = cardNumber => {
  return cardNumber.replace(/\s+/g, "").substr(0, 6);
};

export const clipCardNumber = cardNumber => {
  const defaultCardSize = 16;
  let number = "";
  if (cardNumber.length > defaultCardSize) {
    number = cardNumber.replace(/\s/g, "");
  } else {
    number = cardNumber;
  }
  return number;
};

export const mastBin = cardNumber => {
  return cardNumber.replace(/\d(?=\d{4})/g, "X");
};

export const findCardType = cardNumber => {
  const bin = getBin(cardNumber);
  const cardType = CARD_TYPES.find(card => card.regex.test(bin));
  return cardType ? cardType.name : "UNKNOWN";
};

export const getCardIcon = cardNumber => {
  const cardType = findCardType(cardNumber);
  switch (cardType) {
    case "RUPAY":
      return RupayIcon;
    case "VISA":
      return VisaIcon;
    case "VISA_ELECTRON":
      return VisaElectronIcon;
    case "MASTERCARD":
      return MastercardIcon;
    case "MAESTRO":
      return MaestroIcon;
    case "AMEX":
      return AmexIcon;
    case "DINERS":
      return DinersIcon;
    case "DISCOVER":
      return DiscoverIcon;
    case "JCB":
      return JcbIcon;
    default:
      return CreditCardIcon;
  }
};

export const getCardIconForScheme = cardType => {
  const cardInstance = CARD_TYPES.filter(c => {
    return c.name === cardType;
  });
  return cardInstance[0] ? cardInstance[0].icon : CreditCardIcon;
};

export const getCardDisplayNameForScheme = cardType => {
  const cardInstance = CARD_TYPES.filter(c => {
    return c.name === cardType;
  });
  return cardInstance[0] ? cardInstance[0].displayName : "Card";
};
